import React, { useEffect } from "react";
import * as echarts from "echarts";

const ExpensePieChart = ({ categories, amounts }) => {
  useEffect(() => {
    if (categories.length > 0 && amounts.length > 0) {
      const chartDom = document.getElementById("expenseChart");
      const myChart = echarts.init(chartDom);

      const pieData = categories.map((category, index) => ({
        name: category,
        value: amounts[index],
      }));

      // Define custom colors including emerald green and yellow
      const customColors = [
        "#2ecc71", // Emerald Green
        "#f1c40f", // Yellow
        "#3498db", // Blue
        "#e74c3c", // Red
        "#9b59b6", // Purple
        "#34495e", // Dark Gray
        "#1abc9c", // Teal
        "#e67e22", // Orange
        "#ecf0f1", // Light Gray
      ];

      const option = {
        title: {
          text: "Expense Distribution",
          left: "center",
          textStyle: { color: "#333" },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        
        series: [
          {
            name: "Expenses",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: pieData,
            itemStyle: {
              color: (params) => customColors[params.dataIndex % customColors.length],
              borderRadius: 10,
              borderWidth: 2,
              borderColor: "#fff",
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: {d}%",
              color: "#333",
            },
          },
        ],
      };

      myChart.setOption(option);

      // Resize the chart when the window is resized
      window.addEventListener("resize", () => myChart.resize());

      return () => {
        window.removeEventListener("resize", () => myChart.resize());
      };
    }
  }, [categories, amounts]);

  return (
    <div className="shadow-sm mb-4"
      id="expenseChart"
      style={{ width: "100%", height: "400px", margin: "0 auto" }}
    ></div>
  );
};

export default ExpensePieChart;
